export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.30.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /Users/kestutis/Projects/fifth-avenue/wp-content/themes/5th/node_modules/@sentry/browser/esm/version.js
// module id = 225
// module chunks = 0